/**
 * SearchBar — the ONE omnisearch for the Integrations page (2026-08-18 UX
 * overhaul). Replaces the old pair of inputs (substring catalog box + the
 * exact-match "connect any system" hero): ranked catalog results always
 * render above, and the always-visible custom row below the results is the
 * lane for anything not listed. Matching itself lives in appSearch.ts; this
 * component is presentation only.
 */

import React from 'react';
import panelTheme from '../panelTheme';

export interface SearchBarProps {
  query: string;
  onQueryChange: (q: string) => void;
  /** Catalog size for the placeholder ("search 1,209 apps — or name anything"). */
  catalogCount: number;
  /** Enter pressed in the input (owner ask 2026-08-22: Enter fires the
   *  "connect with Prest0n's browser" offer when that offer leads). The
   *  MOUNT decides whether Enter should do anything — presentation only. */
  onSubmit?: () => void;
  /** The input took focus (the mount fetches what a search will read, 2026-10-08). */
  onFocus?: () => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ query, onQueryChange, catalogCount, onSubmit, onFocus }) => (
  <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.75rem', flexWrap: 'wrap' }}>
    <input
      type="search"
      data-testid="integrations-search"
      onKeyDown={(e) => { if (e.key === 'Enter') onSubmit?.(); }}
      placeholder={
        catalogCount > 0
          ? `search ${catalogCount.toLocaleString()} apps — or name anything with a web login`
          : 'search apps — or name anything with a web login'
      }
      value={query}
      onChange={(e) => onQueryChange(e.target.value)}
      aria-label="Search integrations"
      style={{
        flex: 1, minWidth: '220px', padding: '0.6rem 1rem',
        borderRadius: panelTheme.radiusInput,
        border: `1px solid ${panelTheme.grayBorder}`, fontSize: '0.95rem', outline: 'none',
      }}
      onFocus={(e) => { e.currentTarget.style.border = `1px solid ${panelTheme.gold}`; onFocus?.(); }}
      onBlur={(e) => { e.currentTarget.style.border = `1px solid ${panelTheme.grayBorder}`; }}
    />
  </div>
);

export default SearchBar;
